import Backbone from 'backbone';
import _ from 'underscore';
import Filter from './Filter.js';

//noinspection UnnecessaryLocalVariableJS
const AddFilterButton = Backbone.View.extend(
    {

        tagName: 'div',
        className: 'filter-add',

        /**
         * @constructor
         * @expose
         * @param {Object} options
         * @param {Filter.Config} options.config
         */
        initialize: function (options) {
            this.options = options = Object.assign({}, options);

            this.$el.on('click', _.bind(function () {

                const filter = new Filter({config: options.config, i18n: options.i18n});
                filter.render().$el.insertAfter(this.$el);
                this.trigger('add', filter);
                filter.focusTypeInput();

            }, this));

        },

        render: function () {
            this.$el.text(this.options.text);
            return this;
        },

    },
);

export default AddFilterButton;
